import { IEntityStateStorage } from "@shared/mirage/core/contracts/IEntityStateStorage";

export class EntityTableStateStorage {
    static clear(key: string) {
        if (key) {
            delete this._storage[key.toLowerCase()];
        }
    }
    private static _storage: { [key: string]: IEntityStateStorage } = {};
    public static getState(key: string) {
        return this._storage[key?.toLowerCase()];
    }
    public static setState(key: string, state: IEntityStateStorage) {
        if (key) {
            this._storage[key.toLowerCase()] = state;
        }
    }
}
